export default __webpack_public_path__ + "static/media/elmakon.b02d9968.png";